import React, { useContext, useMemo, useState } from "react";

import { DateUtils as D } from 'simple-utils';
import { buildPeriodList, translatePeriod } from "../account/PeriodSelector";
import { DarkModeToogle } from "../account/table/dark-mode";
import { Modal, useModalHide } from "../components/Modal";
import { logEvent } from "../ga/ga-event-logger";
import { AdDetailContext } from "./DetailStore";


function PeriodSelector(){
    const {state, dispatch} = useContext(AdDetailContext);
    const hide = useModalHide();
    const periodList = useMemo(() => buildPeriodList(2), []);

    async function onChange(newPeriod:string){
        await hide();
        dispatch({type:"setPeriod", period: newPeriod})
    }
    
    return (<>
        <b className="d-block mb-2">Período</b>
        <select className="form-control mb-4" value={state.period || ""} onChange={(e) => onChange(e.target.value)}>
            {periodList.map(e => <option value={e}>{translatePeriod(e)}</option>)}
        </select>
    </>)
}


export function SettingsButton({large = false}:{large?:boolean}){
    const [show, setShow] = useState(false);

    return <>
        <button style={large ? {textDecoration: 'none'} : {}} className="btn btn-link" onClick={()=>setShow(true)}><i className="fa fa-cog"></i>{large && ' Configurações'}</button>
        {show && <Modal className="modal-primary" onHide={() => setShow(false)} title="Escolher Período">
            <DarkModeToogle />
            <PeriodSelector />
        </Modal>}
    </>


}


export function PeriodLabel({short = false}:{short?:boolean}){
    const {state} = useContext(AdDetailContext);
    if(!state.period) return null;
    if(short) return <div className="fw-normal mb-2"><i className="far fa-clock me-2"></i> {translatePeriod(state.period)}</div>
    return <p className="mb-4"><i className="far fa-clock"></i> Período selecionado: <b>{translatePeriod(state.period)}</b></p>
}